export default "__VITE_ASSET__DSK0VSH2__"